import { Guid } from "@/types";


export interface IGetBookingForSelectedAssetDto {
    id: Guid,
    amount: number,
}

export default class BookingForSelectedAsset {
    id: Guid
    amount: number

    constructor({ id, amount }: IGetBookingForSelectedAssetDto) {
        this.id = id
        this.amount = amount

    }
}
